

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { deleteYukBulItems } from "../../../features/admin5/admin5Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 60px;
            margin: 20px 0;
            width: 1100px;
            gap: 40px;
            font-weight: var(--font-weight-md);
            font-size: var(--font-size-sm);
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
`

const YukBulDeletePermissionModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {
        isLoadingDeleteYukBulItems,
        yukBulSelectedMessages
    } = useSelector(state => state.admin5)
    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {

        const idList = yukBulSelectedMessages.map(item => item.id)

        dispatch(deleteYukBulItems({ids: idList}))
    }
    
 
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <p>Seçilen {yukBulSelectedMessages.length} mesajı silmek istediğinize emin misiniz?</p>
           </div>
            <div className='button-grp'>
                <Btn bgColor="#E85446" color="#fff" handleClick={handleSubmit} width={"220px"}>{isLoadingDeleteYukBulItems ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Onayla ve Sil"}</Btn>
                <Btn color="#E85446" bgColor="transparent" width={"220px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default YukBulDeletePermissionModal